import {
  PARTNER_ATTRIBUTION_WINDOW_DAYS_DEFAULT,
  PARTNER_COOKIE_NAME,
} from "@/lib/partners/constants"

const COOKIE_MAX_AGE_SECONDS = PARTNER_ATTRIBUTION_WINDOW_DAYS_DEFAULT * 24 * 60 * 60

const SLUG_PATTERN = /^[a-z0-9][a-z0-9-]{0,48}[a-z0-9]$/

export function normalizePartnerSlug(raw: string | null | undefined): string | null {
  if (!raw) return null
  const slug = raw.trim().toLowerCase()
  if (!SLUG_PATTERN.test(slug)) return null
  return slug
}

export function readPartnerSlugFromDocumentCookie(
  cookieHeader: string,
  name = PARTNER_COOKIE_NAME,
): string | null {
  if (!cookieHeader?.trim()) return null
  const prefix = `${name}=`
  for (const part of cookieHeader.split("; ")) {
    if (!part.startsWith(prefix)) continue
    try {
      const raw = decodeURIComponent(part.slice(prefix.length)).trim()
      return normalizePartnerSlug(raw)
    } catch {
      return null
    }
  }
  return null
}

export function buildPartnerSlugSetCookieValue(
  slug: string,
  isSecure: boolean,
  maxAgeSeconds: number = COOKIE_MAX_AGE_SECONDS,
): string {
  const safe = slug.trim().toLowerCase()
  return `${PARTNER_COOKIE_NAME}=${encodeURIComponent(safe)}; Path=/; Max-Age=${maxAgeSeconds}; SameSite=Lax${isSecure ? "; Secure" : ""}`
}
